import api from "./axios";

export const createSpeaker = async (payload) => {
  const response = await api.post("/speaker", payload);
  return response.data;
};

export const getSpeakers = async (companyId, params = {}) => {
  const response = await api.post("/speaker/search", { company_id: companyId, ...params });
  return response.data;
};

export const getSpeakerById = (id) => {
  return api.get(`/speaker/${id}`);
};

export const updateSpeaker = async (id, payload) => {
  const response = await api.put(`/speaker/${id}`, payload);
  return response.data;
};

export const deleteSpeaker = (id, payload = {}) => {
  return api.put(`/speaker/delete/${id}`, payload);
};

export const getSpeakersByCompany = (companyId) => {
  return api.get(`/speaker/company/${companyId}`);
};